export default {
  info_modal: {
    outside_delivery_radius: {
      title: "Address outside delivery radius",
      description:
        "Your address is outside of our delivery radius. Please change your address or switch to order for pickup.",
      button_title: "Continue",
    },
    location_not_found: {
      title: "Address not found",
      description:
        "Sorry, we couldn't find that address. Please try again by entering first the street in the search address field.",
      button_title: "Continue",
    },
  },
};
